import { useState } from 'react';

const MAX_HISTORY = 1000; // maximum recorded states

interface UseFormHistoryParams {
  initialValues: {[key: string] : string | undefined};
  setValues: (any) => void;
}

const useFormHistory = ({ initialValues, setValues }:UseFormHistoryParams) => {
  const [history, setHistory] = useState([initialValues]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const undo = () => {
    if (currentIndex > 0) {
      const newCurrentIndex = currentIndex - 1;
      setCurrentIndex(newCurrentIndex);
      setValues(values => ({
        ...values,
        ...history[newCurrentIndex],
      }));
    }
  }

  const redo = () => {
    if (currentIndex < history.length - 1) {
      const newCurrentIndex = currentIndex + 1;
      setCurrentIndex(newCurrentIndex);
      setValues(values => ({
        ...values,
        ...history[newCurrentIndex],
      }));
    }
  }

  const push = (values) => {
    const newHistory = history.slice(0, currentIndex + 1).concat([values])
    if (newHistory.length > MAX_HISTORY) {
      newHistory.shift();
    }

    setHistory(newHistory);
    setCurrentIndex(newHistory.length - 1);
  }

  return {
    undo,
    redo,
    push,
    canUndo: history.length > 1 && currentIndex > 0,
    canRedo: history.length > 1 && currentIndex < history.length - 1,
  }
}

export default useFormHistory;
